import { connect } from 'react-redux';
import App from 'components/App';
import { getRoute } from 'routes';
import { uiAction } from 'website/website.actions';

function mapStateToProps(state) {
  const location = state.router.location || window.location;

  return {
    gaTrackingCode: state.website.GA,
    isFetching: getRoute(location).isFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoad: (winWidth) => dispatch(uiAction({ winWidth }))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.container.js